import { transitionEnd, repaint } from 'utils/node';

export default class Overlay {
  public element: HTMLDivElement;

  private readonly classes: { active: string };

  private isActive: boolean;

  constructor(node: HTMLElement = document.body) {
    this.classes = {
      active: 'overlay--active',
    };

    this.isActive = false;
    this.element = Overlay.create.call(this, node);

    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  static create(holder: HTMLElement) {
    const temp = document.createElement('div');
    temp.hidden = true;
    temp.classList.add('overlay');

    holder.appendChild(temp);
    return temp;
  }

  toggle(): void {
    if (this.element.classList.contains(this.classes.active)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show(): void {
    this.isActive = true;
    this.element.hidden = false;
    repaint(this.element);
    this.element.classList.add(this.classes.active);
  }

  hide(): void {
    this.isActive = false;
    this.element.classList.remove(this.classes.active);

    transitionEnd(this.element, () => {
      if (this.isActive === false) {
        this.element.hidden = true;
      }
    }, { once: true });
  }
}
